import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompetencyManagerRoleType, Manager } from 'src/app/Models/organizationModel.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class OthersService {
  constructor(private http: HttpClient){}
  private apiUrl = environment.GSDapiUrl;

  private managerData: Manager;
  private roleMappingFn: (managerRoleType: CompetencyManagerRoleType) => string;

  private triningtype = new BehaviorSubject<any>({});
  public triningtypeid$: Observable<any> = this.triningtype.asObservable();

  private maximizeLayoutSubject = new BehaviorSubject<number>(0)
  public maximizeLayout$ = this.maximizeLayoutSubject.asObservable();

  private tooltype = new BehaviorSubject<any>({});
  public tooltypeid$: Observable<any> = this.tooltype.asObservable();

    private idSubject = new BehaviorSubject<number>(0);
    public id$: Observable<number> = this.idSubject.asObservable();
  
    private nameSubject = new BehaviorSubject<string>('');
    public name$: Observable<string> = this.nameSubject.asObservable();


    private selectedCompetencyID = new BehaviorSubject<number>(0);
    public selectedCompetencyID$: Observable<number> = this.selectedCompetencyID.asObservable();
  
    updateId(id: any) {
      this.idSubject.next(id);
      
    }

    getSelectedSubCompetencyId(): Observable<any> {
      return this.idSubject.asObservable();
    }


    setSelectedCompetencyId(id: number) {
      this.selectedCompetencyID.next(id);
     
    }

    getSelectedCompetencyId(): Observable<any> {
      return this.selectedCompetencyID.asObservable();
    }

    updateName(name: string) {
      this.nameSubject.next(name);
    }
   

    setManagerData(manager: Manager, roleMappingFn: (managerRoleType: CompetencyManagerRoleType) => string) {
      this.managerData = manager;
      this.roleMappingFn = roleMappingFn;
    }
  
    getManagerData(): Manager {
      return this.managerData;
    }
  
    getRoleMappingFn(): (managerRoleType: CompetencyManagerRoleType) => string {
      return this.roleMappingFn;
    }
  
    public GetOthersWidgetCount(compId,subcompId){
      const url=`${this.apiUrl}Tool/getToolsCount?competencyId=${compId}&subcompetencyId=${subcompId}`;
        return this.http.get<any>(url);
    }
    updatetriningtypeId(id) {
      this.triningtype.next(id);
    }
    updatetooltypeId(id) {
     
      this.tooltype.next(id);
    }
    toggleMaximize(value){
      this.maximizeLayoutSubject.next(value)
    }
}
